export type UtilizationWindow = 'live' | 'daily24h' | 'peak';

export interface ChargerUtilization {
  liveOccupancy: number;
  dailyOccupancy24h: number;
  dailyHoursActive: number;
  peakOccupancy: number;
  hourlyUtilization: number[];
}

export type ChargerStatus = 'available' | 'occupied' | 'out_of_service' | 'charged' | 'unknown';
export type ConnectorType = 'Type2' | 'CCS' | 'CHAdeMO';

export interface Charger {
  id: number;
  name: string;
  operator: string;
  operatorCode: string;
  maxKw: number;
  power: 'ac' | 'dc';
  status: ChargerStatus;
  connectors: ConnectorType[];
  coordinates: [number, number];
  live: boolean;
  hasRealStatus?: boolean;
  evseCount?: number;
  evseAvailable?: number;
  evseOccupied?: number;
  priceKwh: number | null;
  settlement: string;
  street: string;
  postalCode: number | null;
  source: string;
  openingHours?: string | null;
  usageCost?: string | null;
  networkNotice?: string | null;
  crowdAt?: string | null;
  wcGas5Min?: boolean;
  cpoGroup?: string;
  occupancyRate?: number;
  dailyOccupancy24h?: number;
  peakOccupancy?: number;
  dailyHoursActive?: number;
  utilization?: ChargerUtilization;
}

export interface FilterState {
  minKw: number;
  connectors: ConnectorType[];
  onlyAvailable: boolean;
  operator: string;
  wcGas5Min?: boolean;
  cpoGroup?: string;
  occupancyRate?: number;
  dailyOccupancy24h?: number;
  peakOccupancy?: number;
  dailyHoursActive?: number;
  utilization?: ChargerUtilization;
}

export const INITIAL_FILTERS: FilterState = {
  minKw: 0,
  connectors: [],
  onlyAvailable: false,
  operator: '',
};

export interface SearchHit {
  type: 'place' | 'operator' | 'charger';
  label: string;
  lat?: number;
  lng?: number;
  id?: number;
  operator?: string;
  nearby?: boolean;
  distance?: string;
  distance_m?: number;
}

export type HeatmapSubMode = 'coverage' | 'intelligence' | 'cpo';
export type CpoFilterGroup = 'all' | 'mobiliti' | 'mol_plugee' | 'tea' | 'eon' | 'tesla' | 'ionity' | 'omv' | 'other';

export interface CpoMetadata {
  id: CpoFilterGroup;
  name: string;
  shortName: string;
  color: string;
  textColor: string;
  borderClass: string;
  bgClass: string;
}

export const CPO_GROUPS: CpoMetadata[] = [
  { id: 'all', name: 'Összes CPO megoszlása', shortName: 'Mind', color: '#10b981', textColor: 'text-emerald-600', borderClass: 'border-emerald-500', bgClass: 'bg-emerald-600' },
  { id: 'mobiliti', name: 'Mobiliti / MVM', shortName: 'Mobiliti', color: '#0ea5e9', textColor: 'text-sky-500', borderClass: 'border-sky-500', bgClass: 'bg-sky-500' },
  { id: 'mol_plugee', name: 'MOL Plugee', shortName: 'MOL Plugee', color: '#84cc16', textColor: 'text-lime-500', borderClass: 'border-lime-500', bgClass: 'bg-lime-500' },
  { id: 'tea', name: 'TEA. Elektromobilitás', shortName: 'TEA.', color: '#f59e0b', textColor: 'text-amber-500', borderClass: 'border-amber-500', bgClass: 'bg-amber-500' },
  { id: 'eon', name: 'E.ON Drive', shortName: 'E.ON', color: '#ef4444', textColor: 'text-red-500', borderClass: 'border-red-500', bgClass: 'bg-red-500' },
  { id: 'tesla', name: 'Tesla Supercharger', shortName: 'Tesla', color: '#e11d48', textColor: 'text-rose-600', borderClass: 'border-rose-600', bgClass: 'bg-rose-600' },
  { id: 'ionity', name: 'IONITY', shortName: 'IONITY', color: '#06b6d4', textColor: 'text-cyan-500', borderClass: 'border-cyan-500', bgClass: 'bg-cyan-500' },
  { id: 'omv', name: 'OMV eMotion', shortName: 'OMV', color: '#3b82f6', textColor: 'text-blue-500', borderClass: 'border-blue-500', bgClass: 'bg-blue-500' },
  { id: 'other', name: 'Egyéb független hálózatok', shortName: 'Egyéb', color: '#8b5cf6', textColor: 'text-purple-500', borderClass: 'border-purple-500', bgClass: 'bg-purple-500' },
];
